<template>
  <div id="tags-view-container" class="tags-view-container">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper">
      <router-link
        v-for="tag in visitedViews"
        ref="tag"
        :key="tag.path"
        :class="isActive(tag)?'active':''"
        :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
        tag="span"
        class="tags-view-item"
        @click.middle.native="closeSelectedTag(tag)"
      >
      <span class="before-style"></span>
      <span class="title-name">{{tag.meta.title}}</span> 
      <span class="after-style"></span>
      <span v-if="!isAffix(tag)" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" />
      </router-link>
    </scroll-pane>
  </div>
</template>
<script>
  import ScrollPane from './ScrollPane'
export default {
  components: { ScrollPane },
  data() {
    return {
      // visitedViews: [
      //   {name: '企微客户', path: '/customer/Eamc', query: {}, fullPath: '/customer/Eamc', meta: {affix: false}},
      //   {name: '员工管理', path: '/system/Staff', query: {}, fullPath: '/system/Staff', meta: {affix: false}},
      //   {name: '聊天审计-员工列表', path: '/chat/StaffChatSupervise', query: {}, fullPath: '/chat/StaffChatSupervise', meta: {affix: false}},
      //   {name: '聊天审计-客户列表', path: '/chat/CusChatSupervise', query: {}, fullPath: '/chat/CusChatSupervise', meta: {affix: false}},
      // ]
    }
  },
  computed: {
    // 原先 this.$store.state.tagsView.visitedViews
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
  },
  watch: {
    $route() {
      this.addTags()
      //this.moveToCurrentTag()
    },
  },
  mounted(){
    this.addTags()
  },
  methods: {
    isActive(route) {
      return route.path === this.$route.path
    },
    isAffix(tag) {
      return tag.meta && tag.meta.affix
    },
    closeSelectedTag(view) {
      this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
      // this.visitedViews = this.arrRemoveJson(this.visitedViews, 'path', view.path)
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view)
        }
      })
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      //this.visitedViews = this.arrRemoveJson(visitedViews, 'path', view.path)
      if (latestView) {
        this.$router.push(latestView.path)
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Indsex') {
          // to reload home page
          this.$router.replace({ path: '/redirect' + view.fullPath })
        } 
        else {
          this.$router.push('/index')
        }
      }
    },
    addTags() {
      const { name } = this.$route
      if (name && name != 'home') {
        this.$store.dispatch('tagsView/addView', this.$route)
      }
      return false
    },
    arrRemoveJson(arr, attr, value){
      if (!arr || arr.length == 0) {
        return ""
      }
      let newArr = arr.filter(function (item, index) {
        return item[attr] != value
      })
      return newArr

    }
  }
}
</script>
<style lang="scss" scoped>
  .show-btns{
    opacity: 1;
  }
  /deep/ .el-scrollbar__view {
    display: flex;
  }
  .tags-view-container {
    height: 38px;
    width: 100%;
    // #F4F7FC
    background: white;
    .tags-view-wrapper {
      .tags-view-item {
        display: inline-block;
        position: relative;
        cursor: pointer;
        height: 38px;
        color: #AAAAAA;
        background: #fff;
        font-size: 12px;
        padding: 0 12px;
        border-radius: 12px 12px 0 0;
        width: 162px;
        margin-right: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title-name {
          flex: 1;
          display: block;
          word-break: break-all;
          text-overflow: ellipsis;
          overflow: hidden;
          -webkit-box-orient: vertical;
          -webkit-line-clamp:1;
        }
        &:first-of-type {
          margin-left: 24px;
        }
        &:last-of-type {
          margin-right: 24px;
        }
        &:hover {
          .el-icon-close {
            @extend .show-btns;
          }
          
        }
        &.active {
          background-color: #F4F7FC;
          color: #3D3D3D;
          .before-style {
            width: 24px;
            height: 100%;
            position: absolute;
            left: -24px;
            background-color: #F4F7FC;
            &::before {
              content: '';
              width: 100%;
              display: block;
              height: 100%;
              border-radius: 0 0 12px 0;
              background-color: white;
            }
          }
          .after-style {
            width: 24px;
            height: 100%;
            position: absolute;
            background-color: #F4F7FC;
            right: -24px;
            &::before {
              content: '';
              width: 100%;
              display: block;
              height: 100%;
              border-radius: 0 0 0 12px;
              background-color: white;
            }
          }
        }
      }
    }
    .contextmenu {
      margin: 0;
      background: #fff;
      z-index: 3000;
      position: absolute;
      list-style-type: none;
      padding: 5px 0;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #333;
      box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
      li {
        margin: 0;
        padding: 7px 16px;
        cursor: pointer;
        &:hover {
          background: #eee;
        }
      }
    }
  }
  .tags-view-wrapper {
    .tags-view-item {
      .el-icon-close {
        width: 16px;
        height: 16px;
        opacity: 0;
        color: #AAAAAA;
        font-size: 14px;
        vertical-align: 2px;
        border-radius: 50%;
        text-align: center;
        transition: all .3s cubic-bezier(.645, .045, .355, 1);
        transform-origin: 100% 50%;
        margin-left: 5px;
        &:before {
          transform: scale(1);
          display: inline-block;
          vertical-align: -3px;
        }
      }
    }
  }
</style>
